// Dizzplace - arkusz szukania otwierany lupa z naglowka na telefonie.
//
// Produkty po wpisaniu slowa daje natywna wyszukiwarka Shopify w alternatywnym,
// stronicowanym widoku `search.sheet.liquid`. IntersectionObserver dociaga po
// 10 kolejnych wynikow, gdy koniec listy zbliza sie do widoku.
//
// Pusty stan (hasla + kafle) i lista podpowiedzi wymieniaja sie miejscami:
// widoczne jest zawsze jedno, wiec arkusz nie rosnie w nieskonczonosc.

(() => {
  const PROG_ZNAKOW = 2;
  const ZWLOKA = 250;

  class SearchSheet extends HTMLElement {
    connectedCallback() {
      if (this.dataset.gotowy === '1') return;
      this.dataset.gotowy = '1';

      this.panel = this.querySelector('.search-sheet__panel');
      this.pole = this.querySelector('[data-search-sheet-input]');
      this.lista = this.querySelector('[data-search-sheet-suggestions]');
      this.pusto = this.querySelector('[data-search-sheet-empty]');
      this.start = this.querySelector('[data-search-sheet-start]');
      this.wyniki = this.querySelector('[data-search-sheet-results]');
      this.loader = this.querySelector('[data-search-sheet-loader]');
      this.czysc = this.querySelector('[data-search-sheet-clear]');
      this.adresWynikow = this.dataset.searchUrl || '/search';
      this.licznik = 0;
      this.kontroler = null;
      this.wyzwalacz = null;
      this.nastepnaStrona = null;
      this.aktywnaFraza = '';
      this.pobieranie = false;

      this.addEventListener('click', (zdarzenie) => {
        if (zdarzenie.target.closest('[data-search-sheet-close]')) this.zamknij();
        if (zdarzenie.target.closest('[data-search-sheet-clear]')) this.wyczysc();
      });

      document.addEventListener('click', (zdarzenie) => {
        const wyzwalacz = zdarzenie.target.closest('[data-search-open]');
        if (!wyzwalacz) return;
        zdarzenie.preventDefault();
        this.otworz(wyzwalacz);
      });

      document.addEventListener('keydown', (zdarzenie) => {
        if (zdarzenie.key === 'Escape' && !this.hidden) this.zamknij();
      });

      if (this.pole) {
        this.pole.addEventListener('input', () => {
          window.clearTimeout(this.zegar);
          const fraza = this.pole.value.trim();
          if (this.czysc) this.czysc.hidden = fraza === '';
          if (fraza.length < PROG_ZNAKOW) {
            this.licznik += 1;
            if (this.kontroler) this.kontroler.abort();
            this.pokazStart();
            return;
          }
          this.zegar = window.setTimeout(() => this.podpowiedz(), ZWLOKA);
        });
      }

      this.podepnijPrzeciaganieUchwytu();
      this.podepnijDociaganie();
    }

    otworz(wyzwalacz) {
      if (!this.hidden) return;
      this.wyzwalacz = wyzwalacz || document.activeElement;
      this.hidden = false;
      window.dizzBlokadaTla?.zablokuj(this);
      window.requestAnimationFrame(() => {
        this.classList.add('search-sheet--otwarty');
        if (this.pole) this.pole.focus();
      });
    }

    zamknij() {
      if (this.hidden) return;
      this.classList.remove('search-sheet--otwarty');
      window.dizzBlokadaTla?.odblokuj();
      if (this.pole) this.pole.blur();
      if (this.kontroler) this.kontroler.abort();
      this.pobieranie = false;

      const koniec = () => {
        this.hidden = true;
        if (this.wyzwalacz && typeof this.wyzwalacz.focus === 'function') this.wyzwalacz.focus();
      };

      if (this.panel) {
        this.panel.addEventListener('transitionend', koniec, { once: true });
        window.setTimeout(koniec, 400);
      } else {
        koniec();
      }
    }

    wyczysc() {
      if (!this.pole) return;
      this.pole.value = '';
      this.pole.focus();
      this.licznik += 1;
      if (this.kontroler) this.kontroler.abort();
      if (this.czysc) this.czysc.hidden = true;
      this.pokazStart();
    }

    pokazStart() {
      if (this.lista) {
        this.lista.hidden = true;
        this.lista.innerHTML = '';
      }
      if (this.pusto) this.pusto.hidden = true;
      if (this.loader) this.loader.hidden = true;
      this.nastepnaStrona = null;
      this.aktywnaFraza = '';
      this.pobieranie = false;
      this.classList.remove('search-sheet--wyniki');
      if (this.start) this.start.setAttribute('aria-hidden', 'false');
      if (this.wyniki) {
        this.wyniki.setAttribute('aria-hidden', 'true');
        this.wyniki.scrollTop = 0;
      }
    }

    pokazWyniki() {
      this.classList.add('search-sheet--wyniki');
      if (this.start) this.start.setAttribute('aria-hidden', 'true');
      if (this.wyniki) {
        this.wyniki.setAttribute('aria-hidden', 'false');
        this.wyniki.scrollTop = 0;
      }
    }

    async podpowiedz() {
      if (!this.pole) return;
      const fraza = this.pole.value.trim();
      if (fraza.length < PROG_ZNAKOW) {
        this.pokazStart();
        return;
      }

      const moj = (this.licznik += 1);
      if (this.kontroler) this.kontroler.abort();
      this.kontroler = new AbortController();
      this.aktywnaFraza = fraza;
      this.nastepnaStrona = null;
      this.pobieranie = true;

      const adres = new URL(this.adresWynikow, window.location.origin);
      adres.searchParams.set('q', fraza);
      adres.searchParams.set('type', 'product');
      adres.searchParams.set('view', 'sheet');
      adres.searchParams.set('options[prefix]', 'last');
      adres.searchParams.set('page', '1');

      let dane = { items: [], next: null };
      try {
        const odpowiedz = await fetch(adres.href, {
          signal: this.kontroler.signal,
        });
        if (!odpowiedz.ok) throw new Error(`Search returned ${odpowiedz.status}`);
        dane = await odpowiedz.json();
      } catch (blad) {
        if (blad.name === 'AbortError') return;
      }
      if (moj !== this.licznik) return;

      this.pobieranie = false;
      this.pokazWyniki();
      if (this.lista) this.lista.replaceChildren();
      const pozycje = Array.isArray(dane.items) ? dane.items : [];
      if (pozycje.length === 0) {
        if (this.lista) this.lista.hidden = true;
        if (this.pusto) this.pusto.hidden = false;
        if (this.loader) this.loader.hidden = true;
        return;
      }

      if (this.pusto) this.pusto.hidden = true;
      this.renderujPozycje(pozycje);
      this.ustawNastepnaStrone(dane.next);
    }

    async doczytaj() {
      if (!this.nastepnaStrona || this.pobieranie) return;
      const moj = this.licznik;
      const adres = this.nastepnaStrona;
      this.pobieranie = true;
      if (this.loader) this.loader.hidden = false;
      this.kontroler = new AbortController();

      let dane = null;
      try {
        const odpowiedz = await fetch(adres, { signal: this.kontroler.signal });
        if (!odpowiedz.ok) throw new Error(`Search returned ${odpowiedz.status}`);
        dane = await odpowiedz.json();
      } catch (blad) {
        if (blad.name === 'AbortError') return;
      }
      if (moj !== this.licznik) return;

      this.pobieranie = false;
      if (!dane) {
        this.nastepnaStrona = null;
        if (this.loader) this.loader.hidden = true;
        return;
      }

      this.renderujPozycje(Array.isArray(dane.items) ? dane.items : []);
      this.ustawNastepnaStrone(dane.next);
    }

    ustawNastepnaStrone(adres) {
      if (!adres) {
        this.nastepnaStrona = null;
        if (this.loader) this.loader.hidden = true;
        return;
      }

      const nastepny = new URL(adres, window.location.origin);
      nastepny.searchParams.set('q', this.aktywnaFraza);
      nastepny.searchParams.set('type', 'product');
      nastepny.searchParams.set('view', 'sheet');
      nastepny.searchParams.set('options[prefix]', 'last');
      this.nastepnaStrona = nastepny.href;
      if (this.loader) this.loader.hidden = false;
    }

    renderujPozycje(pozycje) {
      if (!this.lista || pozycje.length === 0) return;
      const fragment = document.createDocumentFragment();
      pozycje.forEach((pozycja) => {
        const element = document.createElement('li');
        const link = document.createElement('a');
        const tytul = document.createElement('span');
        element.className = 'search-sheet__suggestion search-sheet__suggestion--product';
        link.href = pozycja.url;
        tytul.className = 'search-sheet__suggestion-title';
        tytul.textContent = pozycja.title;

        if (pozycja.image) {
          const media = document.createElement('span');
          const obraz = document.createElement('img');
          media.className = 'search-sheet__suggestion-media';
          obraz.className = 'search-sheet__suggestion-image';
          obraz.src = pozycja.image;
          obraz.alt = pozycja.alt || pozycja.title;
          obraz.width = 72;
          obraz.height = 72;
          obraz.loading = 'eager';
          obraz.decoding = 'async';
          media.append(obraz);
          link.append(media);
        }

        link.append(tytul);
        element.append(link);
        fragment.append(element);
      });
      this.lista.append(fragment);
      this.lista.hidden = false;
    }

    podepnijDociaganie() {
      if (!this.wyniki || !this.loader || !('IntersectionObserver' in window)) return;
      this.obserwator = new IntersectionObserver(
        (wpisy) => {
          if (wpisy.some((wpis) => wpis.isIntersecting)) this.doczytaj();
        },
        { root: this.wyniki, rootMargin: '180px 0px' }
      );
      this.obserwator.observe(this.loader);
    }

    /* Ten sam gest co w menu, filtrach i liscie zyczen: przeciagniecie w dol. */
    podepnijPrzeciaganieUchwytu() {
      const PROG_ZAMKNIECIA = 80;
      let startY = 0;
      let deltaY = 0;
      let przeciaga = false;

      const naRuch = (zdarzenie) => {
        if (!przeciaga || !this.panel) return;
        deltaY = Math.max(0, zdarzenie.clientY - startY);
        this.panel.style.transform = `translateY(${deltaY}px)`;
      };

      const naKoniec = () => {
        if (!przeciaga) return;
        przeciaga = false;
        if (this.panel) {
          this.panel.classList.remove('search-sheet__panel--przeciagane');
          this.panel.style.transform = '';
        }
        if (deltaY > PROG_ZAMKNIECIA) this.zamknij();
        deltaY = 0;
      };

      this.addEventListener('pointerdown', (zdarzenie) => {
        if (!zdarzenie.target.closest('.search-sheet__handle') || !this.panel) return;
        przeciaga = true;
        startY = zdarzenie.clientY;
        deltaY = 0;
        this.panel.classList.add('search-sheet__panel--przeciagane');
        this.setPointerCapture(zdarzenie.pointerId);
      });
      this.addEventListener('pointermove', naRuch);
      this.addEventListener('pointerup', naKoniec);
      this.addEventListener('pointercancel', naKoniec);
    }
  }

  if (!customElements.get('search-sheet')) {
    customElements.define('search-sheet', SearchSheet);
  }
})();
